import { environment } from "@environments/environment";

export const API_URL = {
    getLists: environment.apiHost + 'music/start',
    getAuthToken: environment.apiHost + 'token',
    getRefreshToken: environment.apiHost + 'refreshtoken',
    getSong: environment.apiHost + 'music/getsongs', 
    getCreationSongs: environment.apiHost + 'music/readfiltereduser',
    getMusicUrl: environment.apiHost + 'music/getmusicurl',
    updateSong: environment.apiHost + 'music/update',
    createSong: environment.apiHost + 'music/create',
    deleteSong: environment.apiHost + 'music/delete',
    readFilteredSong: environment.apiHost + 'music/readfiltered',
}